import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { routes } from '@/shared/routes';
import { getLegalEntity } from '@/shared/localization/legalEntity';

export default function Footer() {
  const intl = useIntl();
  const supportEmail = intl.formatMessage({ id: 'email.support' });
  const legalEntity = getLegalEntity();

  return (
    <footer className="py-6 text-center text-sm text-slate-400">
      <div className="flex flex-wrap items-center justify-center gap-2">
        <a
          href={`mailto:${supportEmail}`}
          className="transition-colors hover:text-slate-600"
        >
          <FormattedMessage id="footer.help" />
        </a>
        <span className="text-slate-300">·</span>
        <Link to={routes.terms} className="transition-colors hover:text-slate-600">
          <FormattedMessage id="footer.terms" />
        </Link>
        <span className="text-slate-300">·</span>
        <Link to={routes.privacy} className="transition-colors hover:text-slate-600">
          <FormattedMessage id="footer.privacy" />
        </Link>
        <span className="text-slate-300">·</span>
        <a
          href="https://www.instagram.com/SkipVisaQueue"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 transition-colors hover:text-slate-600"
          aria-label="Instagram"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1.5"/></svg>
          Instagram
        </a>
      </div>
      <div className="mt-4 pt-4 border-t border-slate-200 text-xs text-slate-400">
        <p>
          <FormattedMessage id="footer.copyright" />
        </p>
        {legalEntity && <p className="mt-1 text-slate-400/80">{legalEntity}</p>}
      </div>
    </footer>
  );
}
